
import { Navbar, Row, Col } from 'react-bootstrap';

import '../utils/general.css';
import '../utils/footer.css';

const ECOINDEX_SITE_URL = encodeURIComponent('https://pierresaumet.com/');

export default function Footer() {
  return (
    <Navbar as="footer" expand="lg" bg="dark" data-bs-theme="dark" fixed="bottom" className="justify-content-center mt-5">
      <Row className="align-items-center">
        <Col className="text-center">
          <div>
            <a href={`https://bff.ecoindex.fr/redirect/?url=${ECOINDEX_SITE_URL}`} target="_blank" rel="noreferrer">
              <img src={`https://bff.ecoindex.fr/badge/?theme=dark&url=${ECOINDEX_SITE_URL}`} alt="Ecoindex Badge" />
            </a>
          </div>
          <div>
            <Navbar.Brand>
              <span className='ps-footer'>
                <em>© 2026 Copyright: Pierre Saumet</em>
              </span>
            </Navbar.Brand>
          </div>
        </Col>
      </Row>
    </Navbar>
  )
}
